// import { HumanErrorMessages, MaxCheckableNumber } from '../../constants'
import { api } from '../../libs/api'
import { MySet as Set } from '../../libs/polyfill'

export default {
  namespaced: true,

  state: {
    checkedIds: new Set([]),
    showModal: false,
    opportunityGroups: [],
    searchTags: [],
  },
  getters: {
    sending: state => state.showModal,
    checkedIds: state => state.checkedIds,
    opportunityGroups: state => state.opportunityGroups,
    searchTags: state => state.searchTags,
  },
  mutations: {
    checkedIds: (state, checkedIds) => state.checkedIds = checkedIds,
    showModal: state => state.showModal = true,
    hideModal: state => state.showModal = false,
    opportunityGroups: (state, groups) => state.opportunityGroups = groups,
    searchTags: (state, tags) => state.searchTags = tags,
  },
  actions: {
    async showModal ({ commit }, checkedIds) {
      try {
        const response = await api.fetchOpportunityGroups()
        commit('opportunityGroups', response)
        const responseSearchTags = await api.fetchSearchTags()
        commit('searchTags', responseSearchTags.map(x => x.name))
        commit('checkedIds', checkedIds)
        commit('showModal')
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js